import './ContentPageModals.scss';

import React from 'react';
import Modal from 'components/Modal';
import moment from 'moment';

import Icon from 'components/Icon';
import ModalButton from 'components/ModalButton';
import SlideList from 'components/SlideList';
import Thumbnail from 'components/Thumbnail';

import { generateFileUrl } from 'utils/request';
import { generateContentTypeLabel } from './../utils';

import { FILE_TYPES, FILE_UPLOAD_LOCATIONS, MODALS } from 'utils/constants';

export default class ContentDetailsModal extends React.Component {
    static propTypes = {
        adminEmail: React.PropTypes.string.isRequired,
        closeModal: React.PropTypes.func.isRequired,
        deleteContent: React.PropTypes.func.isRequired,
        isSaving: React.PropTypes.bool.isRequired,
        openModal: React.PropTypes.func.isRequired,
        openPreviewModal: React.PropTypes.func.isRequired,
        show: React.PropTypes.bool.isRequired,
        contentPiece: React.PropTypes.object.isRequired
    };

    _playVideo() {
        let videoPlayer = document.querySelector('video');
        videoPlayer.play();
        videoPlayer.controls = true;
        videoPlayer.style.background = '#000';

        document.querySelector('.content-details__thumbnail--image').classList.add('playing');
    }

    _handlePreviewContent() {
        let { contentPiece } = this.props;
        switch(contentPiece.type) {
            case 'file':
                let contentType = FILE_TYPES[contentPiece.file.contentType];
                if(contentType === 'Video') {
                    this._playVideo();
                } else if(contentType === 'Image' || contentType === 'GIF') {
                    //open content preview
                    this.props.openPreviewModal([this.props.contentPiece]);
                } else {
                    window.open(`${process.env.API_URL}rest/file/${contentPiece.file.id}`)
                }
                break;
            case 'web':
                let uri = contentPiece.uri;
                if(uri.indexOf('http') !== 0) {
                    uri = 'http://' + contentPiece.uri
                }
                window.open(uri, '_blank');
                break;
            case 'html':
                this.props.openPreviewModal([this.props.contentPiece]);
                break;
            default:
                return;
        }
    }

    _generateThumbnailHtml() {
        let { contentPiece } = this.props;
        if(contentPiece.thumbnail) {
            if(contentPiece.file != null) {
                if(FILE_TYPES[contentPiece.file.contentType] === 'Video') {
                    return (
                        <div className="modal__thumbnail--image content-details__thumbnail--image">
                            <video src={generateFileUrl(contentPiece.file, this.props.adminEmail, FILE_UPLOAD_LOCATIONS.UPLOAD)}
                                   preload="auto"
                                   style={{backgroundImage: `url(${generateFileUrl(contentPiece.thumbnail, this.props.adminEmail, FILE_UPLOAD_LOCATIONS.THUMBNAIL)})`}} />
                            <div className="content-details__play--wrapper" onClick={this._playVideo.bind(this)}>
                                <div className="content-details__play">
                                    <Icon icon="play"/>
                                </div>
                            </div>
                        </div>
                    );
                } else if(FILE_TYPES[contentPiece.file.contentType] === 'Image' || FILE_TYPES[contentPiece.file.contentType] === 'GIF') {
                    return (
                        <div className="modal__thumbnail--image content-details__thumbnail--image">
                            <img src={generateFileUrl(contentPiece.file, this.props.adminEmail, FILE_UPLOAD_LOCATIONS.UPLOAD)} alt={contentPiece.name} />
                        </div>
                    );
                } else {
                    return (
                        <div className="modal__thumbnail--image content-details__thumbnail--image">
                            <img src={generateFileUrl(contentPiece.thumbnail, this.props.adminEmail, FILE_UPLOAD_LOCATIONS.THUMBNAIL)} alt={contentPiece.name} />
                        </div>
                    );
                }
            } else {
                return (
                    <div className="modal__thumbnail--image content-details__thumbnail--image">
                        <img src={generateFileUrl(contentPiece.thumbnail, this.props.adminEmail, FILE_UPLOAD_LOCATIONS.THUMBNAIL)} alt={contentPiece.name} />
                    </div>
                );
            }
        } else {
            return (
                <Thumbnail defaultAvatar={contentPiece.marketingType && contentPiece.marketingType === 'elearning' ? 'elearning' : contentPiece.type}
                           thumbnailID={null} />
            );
        }
    }

    _generatePreviewButton() {
        let { contentPiece, isSaving } = this.props;
        let icon = 'play';
        let text = 'Preview';
        if((contentPiece.type === 'file' && (FILE_TYPES[contentPiece.file.contentType] === 'Image' || FILE_TYPES[contentPiece.file.contentType] === 'Video'))
            || contentPiece.type === 'html') {
            icon = 'play';
        } else if(contentPiece.type === 'web') {
            if(contentPiece.marketingType && contentPiece.marketingType === 'elearning') {
                icon = 'elearning';
            } else {
                icon = 'link';
            }
            text = 'Open Link';
        }else if(['checklist', 'survey', 'assessment'].indexOf(contentPiece.type) === -1) {
            icon = 'download';
            text = 'Download'
        }

        return (
            <ModalButton disabled={isSaving === true}
                         icon={icon}
                         onClick={this._handlePreviewContent.bind(this)}
                         text={text} />
        )
    }

    render() {
        let { closeModal, contentPiece, deleteContent, openModal, isSaving, show } = this.props;

        if(Object.keys(contentPiece).length > 0 && contentPiece.id != null) {
            return (
                <Modal show={show}
                       className="content-details"
                       handleClose={closeModal.bind(this)}>
                    <header className="content-details__header modal__header">
                        <div className="content-details__thumbnail modal__thumbnail">
                            {this._generateThumbnailHtml()}
                            <div className="content-details__type">
                                {generateContentTypeLabel(contentPiece)}
                            </div>
                        </div>
                    </header>
                    <div className="details-modal__info content-details__info">
                        <div className="content-details__name modal__name">
                            {contentPiece.name}
                        </div>
                        <div className="content-details__description modal__description">
                            Created by {contentPiece.creator.firstName} {contentPiece.creator.lastName} | {moment(contentPiece.created).format('MM/DD/YY')}
                        </div>
                    </div>

                    <SlideList className="content-details__assignments-list content-details__list details-modal__list"
                               count={contentPiece.assignmentIds ? contentPiece.assignmentIds.length : 0}
                               icon="assignments"
                               items={contentPiece.assignments || []}
                               title="Assignments"
                               type="assignments--names-only" />

                    <div className="details-modal__info content-details__info">
                        <div className="content-details__name modal__name">
                            Description
                        </div>
                        <div className="group-details__description modal__description">
                            {contentPiece.description || '[No specified description]'}
                        </div>
                    </div>

                    <div className="modal__buttons">
                        {contentPiece.type === 'file' ? (
                            <ModalButton disabled={isSaving === true}
                                         icon="edit"
                                         onClick={openModal.bind(this, MODALS.CONTENT_EDIT_FILE_UPLOAD)}
                                         text="Edit" />
                        ) : null}

                        {contentPiece.type === 'checklist' ? (
                            <ModalButton disabled={isSaving === true}
                                         icon="edit"
                                         onClick={openModal.bind(this, MODALS.CONTENT_EDIT_CHECKLIST)}
                                         text="Edit" />
                        ) : null}

                        {this._generatePreviewButton()}

                        <ModalButton disabled={isSaving === true}
                                     icon="delete"
                                     onClick={deleteContent.bind(this, contentPiece)}
                                     text="Remove" />
                    </div>

                </Modal>
            )
        } else {
            return null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/containers/ContentPage/modals/ContentDetailsModal.js